import Keycloak from 'keycloak-js'
import { createContext, useContext } from 'react';

export const keycloak = new Keycloak({
  url: process.env.REACT_APP_SERVER_URL,
  realm: process.env.REACT_APP_REALM_NAME,
  clientId: process.env.REACT_APP_CLIENT_ID,
});

export const KeycloakContext = createContext(null);

export const useKeycloak = () => {
  const context = useContext(KeycloakContext);
  if (!context) {
    throw new Error('useKeycloak must be used within KeycloakProvider');
  }
  return context;
};